import { render, staticRenderFns } from "./yearly_area_product.vue?vue&type=template&id=220345f3&scoped=true"
import script from "./yearly_area_product.vue?vue&type=script&lang=js"
export * from "./yearly_area_product.vue?vue&type=script&lang=js"
import style0 from "./yearly_area_product.vue?vue&type=style&index=0&id=220345f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220345f3",
  null
  
)

export default component.exports